<template>
  <section class="logout-container">
    <span class="message">U wordt nu uitgelogd...</span>
    <bouncing-spinner class="spinner-ct"></bouncing-spinner>
  </section>
</template>

<script>
export default {
  name: 'LoggingOut',
}
</script>

<style scoped lang="scss">
.logout-container {
  display: flex;
  flex-direction: column;
  margin: 20px;
  justify-content: center;
  align-items: center;
  .message {
    margin-bottom: 20px;
  }
}
</style>
